/* eslint-disable react/jsx-filename-extension */
/* eslint-disable no-unused-vars */
import React from "react";
import logo from "./logo.svg";
import "./App.css";
import Router from "./Router";

function App() {
  return <Router />;
}

export default App;
